var React = require('react');

function Sun48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 24.999H37a1 1 0 1 1 0-2h10a.999.999 0 1 1 0 2zM35.708 13.205a.994.994 0 0 1-1.414 0 .998.998 0 0 1 0-1.413l6-6a.999.999 0 1 1 1.414 1.414l-6 5.999zm-.001 20.587l6 6a.999.999 0 1 1-1.414 1.414l-6-6a.999.999 0 1 1 1.414-1.414zM24 32.497c-4.963 0-9-4.037-9-8.999 0-4.962 4.037-8.999 9-8.999s9 4.037 9 8.999c0 4.962-4.037 8.999-9 8.999zm0-15.999c-3.859 0-7 3.142-7 7 0 3.86 3.141 6.998 7 6.998s7-3.138 7-6.998c0-3.858-3.141-7-7-7zm0-4.499a1 1 0 0 1-1-1v-10a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1zM7.708 41.206a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6-6a.999.999 0 1 1 1.414 1.414l-6 6zM13 13.499a.994.994 0 0 1-.707-.294l-6-5.999a.999.999 0 1 1 1.414-1.414l6 6a.998.998 0 0 1 0 1.413.994.994 0 0 1-.707.294zm-1 10.499a1 1 0 0 1-1 1.001H1a1 1 0 1 1 0-2h10c.553 0 1 .447 1 .999zm12 12.001a1 1 0 0 1 1 1v9.999a1 1 0 1 1-2 0v-9.999a1 1 0 0 1 1-1z","key":1})]);
}

Sun48px.displayName = "Sun48px";

Sun48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};

module.exports = Sun48px;

Sun48px.default = Sun48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/sun-48px.svg
// module id = 1168
// module chunks = 0